import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { keys } from './keys';

async function fetchInboxSyncStatus(spaceId: string): Promise<string | null> {
  const { data, error } = await apiClient
    .from('spaces')
    .select('last_inbox_sync_at')
    .eq('id', spaceId)
    .single();

  if (error) {
    throw error;
  }

  return data?.last_inbox_sync_at ?? null;
}

type Props = {
  spaceId?: string;
};

export function useGetInboxSyncStatus(props: Props) {
  return useQuery({
    queryKey: keys.syncStatus(props.spaceId ?? ''),
    queryFn: () => fetchInboxSyncStatus(props.spaceId!),
    enabled: Boolean(props.spaceId),
    refetchInterval: 30_000, // Poll every 30 seconds to show live sync updates
  });
}
